import React, { ReactElement, useEffect } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { CoverageCheckupState } from '../../../store/step';
import { Field, useFormikContext } from 'formik';
import CheckboxTile from '@ramsey-design-system/checkbox-tile';
import { FormikFormMultiField } from '../../shared/FormikFormMultiField';

function SeparateInsurancePoliciesStepForm(): ReactElement {
  const { values, setFieldValue } = useFormikContext<CoverageCheckupState>();

  function handleNoneOfTheseChange(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    const isChecked = event.target.checked;

    // Uncheck all other checkboxes if "None of these" is checked
    if (isChecked) {
      setFieldValue('cancerInsurancePossessed', false);
      setFieldValue('accidentalDeathInsurancePossessed', false);
      setFieldValue('mortgageLifeInsurancePossessed', false);
      setFieldValue('accidentOrSicknessInsurancePossessed', false);
      setFieldValue('petInsurancePossessed', false);
      setFieldValue('homeWarrantyInsurancePossessed', false);
      setFieldValue('cellPhoneInsurancePossessed', false);
    }

    // Update "None of these" checkbox value
    setFieldValue('noneOfThese', isChecked);
  }

  useEffect(() => {
    // Uncheck "None of these" if any other checkbox is checked
    if (
      values.cancerInsurancePossessed ||
      values.accidentalDeathInsurancePossessed ||
      values.mortgageLifeInsurancePossessed ||
      values.accidentOrSicknessInsurancePossessed ||
      values.petInsurancePossessed ||
      values.homeWarrantyInsurancePossessed ||
      values.cellPhoneInsurancePossessed
    ) {
      setFieldValue('noneOfThese', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <FormikFormMultiField name="noneOfThese">
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="canerInsurancePossessed"
          name="cancerInsurancePossessed"
          label="Cancer insurance"
          data-testid="cancer_insurance_possessed"
          checked={values.cancerInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="accidentalDeathInsurancePossessed"
          name="accidentalDeathInsurancePossessed"
          label="Accidental death insurance"
          data-testid="accidental_death_insurance_possessed"
          checked={values.accidentalDeathInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="mortgageLifeInsurancePossessed"
          name="mortgageLifeInsurancePossessed"
          label="Mortgage life insurance"
          data-testid="mortgage_life_insurance_possessed"
          checked={values.mortgageLifeInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="accidentOrSicknessInsurancePossessed"
          name="accidentOrSicknessInsurancePossessed"
          label="Accident/sickness insurance"
          data-testid="accident_sickness_insurance_possessed"
          checked={values.accidentOrSicknessInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="petInsurancePossessed"
          name="petInsurancePossessed"
          label="Pet insurance"
          data-testid="pet_insurance_possessed"
          checked={values.petInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="homeWarrantyInsurancePossessed"
          name="homeWarrantyInsurancePossessed"
          label="Home warranty insurance"
          data-testid="home_warranty_insurance_possessed"
          checked={values.homeWarrantyInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="cellPhoneInsurancePossessed"
          name="cellPhoneInsurancePossessed"
          label="Cell phone insurance"
          data-testid="cell_phone_insurance_possessed"
          checked={values.cellPhoneInsurancePossessed === true}
          size="sm"
        />
        <Field
          className="mb-1.5 max-w-[300px]"
          as={CheckboxTile}
          type="checkbox"
          id="noneOfThese"
          name="noneOfThese"
          label="None of these"
          data-testid="none_of_these"
          checked={values.noneOfThese === true}
          size="sm"
          onChange={handleNoneOfTheseChange}
        />
      </FormikFormMultiField>
      <NavigationButtons />
    </>
  );
}

export { SeparateInsurancePoliciesStepForm };
